export type StandardUnit = 'piece' | 'gram' | 'kilogram' | 'milliliter' | 'centiliter' | 'deciliter' | 'liter' | 'teaspoon' | 'tablespoon' | 'cup';

export interface UnitTranslation {
  en: string;
  fr: string;
  abbreviation: string;
}

export const standardUnits: Record<StandardUnit, UnitTranslation> = {
  piece: {
    en: 'Piece',
    fr: 'Pièce',
    abbreviation: 'pc'
  },
  gram: {
    en: 'Gram',
    fr: 'Gramme',
    abbreviation: 'g'
  },
  kilogram: {
    en: 'Kilogram',
    fr: 'Kilogramme',
    abbreviation: 'kg'
  },
  milliliter: {
    en: 'Milliliter',
    fr: 'Millilitre',
    abbreviation: 'ml'
  },
  centiliter: {
    en: 'Centiliter',
    fr: 'Centilitre',
    abbreviation: 'cl'
  },
  deciliter: {
    en: 'Deciliter',
    fr: 'Décilitre',
    abbreviation: 'dl'
  },
  liter: {
    en: 'Liter',
    fr: 'Litre',
    abbreviation: 'l'
  },
  teaspoon: {
    en: 'Teaspoon',
    fr: 'Cuillère à Café',
    abbreviation: 'tsp'
  },
  tablespoon: {
    en: 'Tablespoon',
    fr: 'Cuillère à Soupe',
    abbreviation: 'tbsp'
  },
  cup: {
    en: 'Cup',
    fr: 'Tasse',
    abbreviation: 'cup'
  }
};